import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-left-down-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "m6 11 2.5 2.5L11 11" }),
        React.createElement("path", { d: "M8.5 13V6A2.5 2.5 0 0 1 11 3.5h0" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
